import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import _ from "lodash";
import { Form } from "antd";

import RegistrationTemplate from "../../../../components/RegistrationTemplate";

import { formDataFields } from "../../formData";

import { getUpdatedData } from "../../hooks/use-helpers";

import {
  getSubmissionData,
  prepareAddressFormData,
} from "../../hooks/address-form-helper";

import HexLoader from "../../../../components/HexLoader";

import MapAddress from "./MapAddress";

import RegistrationLayout from "../../../Main/RegistrationLayout";
import HexButton from "../../../../ui-kit/HexButtons";
import FormFactory from "../../../../components/FormFactory";

import "../../styles.css";
import "../../theme.css";

const ConsumerAddress = ({ onBack, onSave, addressDetails, submitted }) => {
  const addressConfigs = formDataFields()["address-information"];
  const { text, fields, viewHeight, formHandler } = addressConfigs;

  const countryOptions = useSelector(
    (state) => state.publicAPIs.countryOptions
  );

  const [form] = Form.useForm();
  const [errors, setErrors] = useState({});

  const [apiLoader, setAPILoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [mapView, setMapView] = useState(true);

  const [formFields, setFormFields] = useState(fields);
  const [consumerAddress, setConsumerAddress] = useState(addressDetails);

  useEffect(() => {
    loadFieldsData(addressDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadFieldsData = (address) => {
    if (!_.isEmpty(address)) {
      prepareAddressFormData(address, fields, countryOptions, (formData) => {
        setFormFields(formData);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  };

  const onChangeHandler = (value, key) => {
    const requestData = {
      type: formHandler,
      value,
      key,
      formFields,
      errors,
    };

    getUpdatedData(requestData, (data) => {
      const { updatedFields, fieldErrors } = data;
      const updatedErrors = { ...errors };
      updatedErrors[key] = "";

      setErrors(fieldErrors);
      setFormFields(updatedFields);
    });
  };

  const formSubmitDataHandler = () => {
    const { required, fieldsData } = getSubmissionData(formFields);
    if (!_.isEmpty(required)) {
      setErrors(required);
    } else {
      onSave(fieldsData, submitted);
    }
  };

  const onSaveMapAddress = (address) => {
    setAPILoader(true);

    prepareAddressFormData(address, fields, countryOptions, (formData) => {
      setFormFields(formData);
      setConsumerAddress(address);
      setAPILoader(false);
      setMapView(false);
    });
  };

  const { address1, location } = consumerAddress || {
    address1: "",
    location: { latitude: "", longitude: "" },
  };

  return (
    <RegistrationLayout className="profile-layout business" viewHeight={viewHeight}>
      <RegistrationTemplate
        containerName="business"
        sectionName={"address-information"}
        configs={addressConfigs}
        headerLogo={true}
        goBack={true}
        footerLogo={true}
        onBack={onBack}
      >
        {loading ? (
          <HexLoader />
        ) : (
          <div className="business__listing">
            {!mapView && (
              <Form
                layout="vertical"
                form={form}
                onFinish={formSubmitDataHandler}
              >
                <FormFactory
                  formElementsTypes={formFields}
                  onChangeHandler={onChangeHandler}
                  errors={errors}
                />
              </Form>
            )}

            {mapView && (
              <MapAddress
                onSave={onSaveMapAddress}
                addressText={address1}
                {...location}
              />
            )}
          </div>
        )}

        {apiLoader ? (
          <HexLoader />
        ) : (
          !mapView && (
            <div className="business__btn">
              <HexButton
                label={text}
                onClick={() => form.submit()}
                type="primary"
                size="lg"
                htmlType="submit"
                html
              />
            </div>
          )
        )}
      </RegistrationTemplate>
    </RegistrationLayout>
  );
};

export default ConsumerAddress;
